import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref, computed as _computed } from 'vue';

import { watch } from 'vue';
import { AssetService, LineageEntityDto } from '@/api';
import type {
  AuthorizedAssetHeaderDto,
  DagAssetOverview,
  DashboardAssetOverview,
  DatasetAssetOverview,
  UnauthorizedAssetHeaderDto,
  DeclaredAssetOverview,
  TransformationAssetOverview,
} from '@/api';
import { getProviderIconSrc } from '@/utils/provider-icons';
import AccessDenied from '@/components/panels/Access-Denied.vue';
import AssetOverviewDetail from '@/components/asset/overview/Asset-Overview-Detail.vue';
import AssetOverviewTransformationPanel from '@/components/asset/overview/Asset-Overview-Transformation-Panel.vue';
import OrchestrationStatus from '@/components/asset/overview/Orchestration-Status.vue';
import TransformationStatus from '@/components/asset/overview/Transformation-Status.vue';

interface DatasetPanelProps {
  urn: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Dataset-Panel',
  props: {
  urn: null
},
  setup(__props) {

const props = __props;


let headerInfo: AuthorizedAssetHeaderDto | UnauthorizedAssetHeaderDto | null = _ref(null);
let overviewData: DagAssetOverview | DashboardAssetOverview | DatasetAssetOverview | DeclaredAssetOverview | TransformationAssetOverview | null = _ref(null);
let assetData = _ref<AuthorizedAssetHeaderDto | UnauthorizedAssetHeaderDto | null>(null);
let isAuthorized: null | undefined | boolean = _ref(null);

const associatedDomainsNames = _computed(() => (headerInfo.value ? (headerInfo.value as UnauthorizedAssetHeaderDto).associatedDomainsNames : []));

const qualityStatus = _computed(() => headerInfo.value?.qualityStatus);
const dagRun = _computed(() => headerInfo.value?.dagRunDto);
const dbtModel = _computed(() => headerInfo.value?.dbtModelDto);
const image = _computed(() => getProviderIconSrc(headerInfo.value?.lineagePlatform));
const uri = _computed(() => {
  if (headerInfo.value && 'uri' in headerInfo.value) return headerInfo.value.uri;

  return '';
});

const getAssetOverview = async () => {
  headerInfo.value = await AssetService.getAssetHeaderByUrn({ urn: props.urn });
  isAuthorized.value = headerInfo.value.accessAuthorized;
  if (!isAuthorized.value) return;
  overviewData.value = await AssetService.getAssetOverviewByUrn({ urn: props.urn });
};

const getAsset = async () => {
  assetData.value = await AssetService.getAssetHeaderByUrn({ urn: props.urn });
};

const updateHandler = () => {
  getAssetOverview();
};

const detailComponent = _computed(() => {
  if (!headerInfo.value) return null;

  if (headerInfo.value.entityType === LineageEntityDto.entityType.TRANSFORMATION) {
    return AssetOverviewTransformationPanel;
  }

  return AssetOverviewDetail;
});
const typeLabel = _computed(() => headerInfo.value?.displayedTypeLabel || headerInfo.value?.displayedType);

const qualifiedNamePrefix = _computed(() => headerInfo.value?.qualifiedNamePrefix);

const label = _computed(() => (qualifiedNamePrefix.value === undefined ? typeLabel.value : `${typeLabel.value} - ${qualifiedNamePrefix.value}`));

watch(() => props.urn, () => {
  getAssetOverview();
  getAsset();
}, { immediate: true });

return { __sfc: true,props, headerInfo, overviewData, assetData, isAuthorized, associatedDomainsNames, qualityStatus, dagRun, dbtModel, image, uri, getAssetOverview, getAsset, updateHandler, detailComponent, typeLabel, qualifiedNamePrefix, label, _ref, _computed, watch, AssetService, LineageEntityDto, getProviderIconSrc, AccessDenied, AssetOverviewDetail, AssetOverviewTransformationPanel, OrchestrationStatus, TransformationStatus }
}

})